import {Directive, HostListener, Input, Output, EventEmitter, ElementRef} from '@angular/core';

@Directive({
  selector: '[validator-date]',
  standalone: true
})

export class ValidatorDateDirective {
  dateValue = '';
  @Output() dateChange: EventEmitter<string | null | Date> = new EventEmitter<string | null | Date>();
  @Input('date-value') modelValue: any;
  @Input() isStartDate: boolean = false;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length >= 10 && event.key !== 'Backspace') {
      event.preventDefault();
      return;
    }

    if (event.key === 'Backspace') {
      const caretStart = input.selectionStart ?? 0;
      const caretEnd = input.selectionEnd ?? 0;
      if (input.value[caretStart - 1] === '.' && !isNaN(parseInt(input.value[caretStart - 2]))) {
        const valueBeforeCaret = input.value.slice(0, caretStart - 1);
        const valueAfterCaret = input.value.slice(caretEnd);
        input.value = valueBeforeCaret + valueAfterCaret;
        event.preventDefault();
        input.setSelectionRange(caretStart - 1, caretStart - 1);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') || '';
    const digits = clipboardData.replace(/[^\d]/g, '');
    if (digits.length > 8) { // Максимум 8 цифр для DDMMYYYY
      event.preventDefault();
      const truncatedDigits = digits.slice(0, 8);
      this.formatAndSetValue(truncatedDigits);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el.nativeElement;
    let value = input.value.replace(/[^\d]/g, '');

    // Обрезаем до 8 цифр (DDMMYYYY)
    if (value.length > 8) {
      value = value.slice(0, 8);
    }

    this.formatAndSetValue(value);
  }

  private formatAndSetValue(value: string): void {
    const input = this.el.nativeElement;
    let formattedValue = '';

    // Форматируем в DD.MM.YYYY
    if (value.length > 0) {
      formattedValue = value.slice(0, 2); // День
      if (value.length > 2) {
        formattedValue += '.' + value.slice(2, 4); // Месяц
      }
      if (value.length > 4) {
        formattedValue += '.' + value.slice(4, 8); // Год
      }
    }

    // Проверка дня
    const day = parseInt(value.slice(0, 2), 10) || 0;
    if (day > 31) {
      formattedValue = '31' + formattedValue.slice(2);
    } else if (day < 1 && value.length >= 2) {
      formattedValue = '01' + formattedValue.slice(2);
    }

    // Проверка месяца
    const month = parseInt(value.slice(2, 4), 10) || 0;
    if (month > 12) {
      formattedValue = formattedValue.slice(0, 3) + '12' + formattedValue.slice(5);
    } else if (month < 1 && value.length >= 4) {
      formattedValue = formattedValue.slice(0, 3) + '01' + formattedValue.slice(5);
    }

    // Проверка года
    const currentYear = new Date().getFullYear();
    const year = parseInt(value.slice(4, 8), 10);
    if (value.length > 4 && year > currentYear) {
      formattedValue = formattedValue.slice(0, 6) + currentYear.toString();
    }

    input.value = formattedValue;
    this.dateValue = formattedValue;
    this.dateChange.emit(formattedValue);
  }
}
